import React, { useState } from 'react';
import { image } from "../../common/Theme";
import { Header } from "../../component/Header";
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Checkbox, FormControlLabel, Chip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PolicyModal from "../../component/PolicyModal";

const BookingSummary = () => {
    const navigate = useNavigate();
    const [noRefundAccepted, setNoRefundAccepted] = useState(false);
    const [policyModalOpen, setPolicyModalOpen] = useState(false);
    const [policyModalTab, setPolicyModalTab] = useState('terms');

    const handleSubmit = async () => {
        if (!noRefundAccepted) return;
        navigate('/payment-details');
    };

    const handleSubmit1 = async () => {
        navigate('/booking-create');
    };

    const openPolicy = (tab) => {
        setPolicyModalTab(tab);
        setPolicyModalOpen(true);
    };

    return (
        <>
            <div className="booking-main" style={{
                backgroundImage: `url(${image.bodybg})`,
            }}>
                <div className="booking-inner">
                    <Header />

                    <div className="booking-inner-content">
                        <div className="row ">
                            <div className="col-lg-6">
                                <div className="inner-right ">
                                    <h2>Booking Summary</h2>
                                    <div className="booking-summry">
                                        <div className="summry-box">
                                            <h4>Drop Off Date &amp; Time</h4>
                                            <span>09 Sept 2024 | 17:45</span>
                                        </div>
                                        <div className="summry-box">
                                            <h4>Pick Up Date &amp; Time</h4>
                                            <span>12 Sept 2024 | 17:45</span>
                                        </div>
                                        <div className="summry-box">
                                            <h4>License Plate No.</h4>
                                            <span>NY 1234 HJ</span>
                                        </div>
                                        <div className="summry-box">
                                            <h4>Vehicle Type </h4>
                                            <span>Sedan</span>
                                        </div>
                                        <div className="summry-box">
                                            <h4>Total Duration</h4>
                                            <span>For 4 days</span>
                                        </div>
                                        <div className="summry-box">
                                            <h4>Total Amount</h4>
                                            <span>$ 189.56</span>
                                        </div>
                                        <div className="summry-box" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h4>Reservation Fee</h4>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <span style={{ fontWeight: 700 }}>$25.00</span>
                                                <Chip 
                                                    label="Non-refundable" 
                                                    size="small" 
                                                    sx={{ backgroundColor: '#fee2e2', color: '#b91c1c', fontSize: '11px', fontWeight: 800, height: '20px' }} 
                                                />
                                            </Box>
                                        </div>

                                        {/* No-Refund Message Banner */}
                                        <Box
                                            sx={{
                                                backgroundColor: '#fffbeb',
                                                border: '1px solid #fde68a',
                                                borderRadius: '12px',
                                                p: 2,
                                                my: 2,
                                                display: 'flex',
                                                gap: 1.5,
                                                alignItems: 'flex-start',
                                                textAlign: 'left'
                                            }}
                                        >
                                            <InfoOutlinedIcon sx={{ color: '#d97706', fontSize: '20px', mt: 0.2, flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: '12.5px', color: '#78350f', lineHeight: 1.5 }}>
                                                <strong>No-Refund Policy Notice:</strong> The $25 reservation fee is non-refundable. Total remaining amount is payable at the location. Trucks and oversized vehicles are accepted with additional on-site charges.
                                            </Typography>
                                        </Box>

                                        {/* Mandatory Checkbox */}
                                        <Box sx={{ my: 2, textAlign: 'left', p: 1.5, backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={noRefundAccepted}
                                                        onChange={(e) => setNoRefundAccepted(e.target.checked)}
                                                        sx={{ color: '#004777', '&.Mui-checked': { color: '#004777' } }}
                                                    />
                                                }
                                                label={
                                                    <Typography sx={{ fontSize: '12px', color: '#334155', fontWeight: 500, lineHeight: 1.4 }}>
                                                        I have read and agree to the{' '}
                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openPolicy('terms');
                                                            }}
                                                            style={{ color: '#004777', textDecoration: 'underline', fontWeight: 700, cursor: 'pointer' }}
                                                        >
                                                            Terms of Service
                                                        </span>{' '}
                                                        and explicitly authorize this transaction. I understand and accept the{' '}
                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openPolicy('refund');
                                                            }}
                                                            style={{ color: '#004777', textDecoration: 'underline', fontWeight: 700, cursor: 'pointer' }}
                                                        >
                                                            Strict No-Refund Policy
                                                        </span>
                                                        , and agree that all fees paid for Prime Park are final and non-refundable.
                                                    </Typography>
                                                }
                                                sx={{ alignItems: 'flex-start', m: 0 }}
                                            />
                                        </Box>

                                        <div className="submit-btn" style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
                                            <button className="cancel-btn" onClick={handleSubmit1} style={{ flex: 1 }}>Back</button>
                                            <button 
                                                className="accept-btn" 
                                                onClick={handleSubmit} 
                                                disabled={!noRefundAccepted}
                                                style={{
                                                    flex: 1,
                                                    backgroundColor: !noRefundAccepted ? '#94a3b8' : '#004777',
                                                    cursor: !noRefundAccepted ? 'not-allowed' : 'pointer',
                                                    opacity: !noRefundAccepted ? 0.7 : 1,
                                                    transition: 'all 0.3s'
                                                }}
                                            >
                                                Proceed to Pay
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="inner-left">
                                    <img src={image.bigcar} alt="" className="car-imgg" />
                                    <img src={image.dotscircle} alt="" className="rotate-dots" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PolicyModal
                open={policyModalOpen}
                onClose={() => setPolicyModalOpen(false)}
                initialTab={policyModalTab}
                onAccept={() => setNoRefundAccepted(true)}
            />
        </>
    );
};

export default BookingSummary;